import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SetPinDialogComponent} from './components/dialogs/set-pin-dialog/set-pin-dialog.component';
import {TransactionsTableComponent} from './components/transactions-table/transactions-table.component';
import {UserBoardComponent} from './components/user-board/user-board.component';
// eslint-disable-next-line max-len
import {RouterModule} from '@angular/router';
import {DashboardComponent} from './dashboard.component';
import {DialogProgressModule} from '../shared/components/dialog-progress/dialog-progress.module';
import {InputModule} from '../shared/components/input/input.module';
import {ReactiveFormsModule} from '@angular/forms';
import {DropdownModule} from '../shared/components/dropdown/dropdown.module';
import {PinInputModule} from '../shared/components/pin-input/pin-input.module';
import {SetUpComponent} from './components/set-up/set-up.component';
import {SearchInputModule} from '../shared/components/search-input/search-input.module';
import {MenuModule} from '../shared/components/menu/menu.module';
import {BadgeModule} from '../shared/components/badge/badge.module';
import {DialogModule} from '../shared/components/dialog/dialog.module';
import {InputSearchScannerModule} from '../shared/components/input-search-scanner/input-search-scanner.module';
import {PharmacyDetailsModule} from '../shared/components/pharmacy-details/pharmacy-details.module';
import {AmendDialogModule} from '../shared/components/amend-dialog/amend-dialog.module';
import {ButtonModule} from '../shared/components/button/button.module';
import {EnterPinDialogModule} from '../shared/components/enter-pin-dialog/enter-pin-dialog.module';
import {AlertModule} from '../shared/components/alert/alert.module';
import {ResetPinDialogModule} from '../shared/components/reset-pin-dialog/reset-pin-dialog.module';
import {FormattedDateModule} from '../shared/pipes/formatted-date/formatted-date.module';
import {FormattedDatePipe} from '../shared/pipes/formatted-date/formatted-date.pipe';
import {SearchEmptySplashModule} from '../shared/components/search-empty-splash/search-empty-splash.module';
import { PendingTransactionsCarouselComponent } from './components/transactions-table/pending-transactions-carousel/pending-transactions-carousel.component';
import { LoaderModule } from '../shared/components/loader/loader.module';
import { DispenseDialogModule } from './components/user-board/dialogs/dispense-dialog/dispense-dialog.module';
import { ReceiveDialogModule } from './components/user-board/dialogs/receive-dialog/receive-dialog.module';
import { SellToPharmacyDialogModule } from './components/user-board/dialogs/sell-to-pharmacy-dialog/sell-to-pharmacy-dialog.module';
import { RecordLostStolenDialogModule } from './components/user-board/dialogs/record-lost-stolen-dialog/record-lost-stolen-dialog.module';
import { RecordDamagedExpiredDialogModule } from './components/user-board/dialogs/record-damaged-expired-dialog/record-damaged-expired-dialog.module';
import { PendingTransactionCardsModule } from './components/transactions-table/pending-transactions-carousel/pending-transaction-card/pending-transaction-cards.module';
import { PendingTransactionDialogModule } from './components/user-board/dialogs/pending-transaction-dialog/pending-transaction-dialog/pending-transaction-dialog.module';
import { MultipleDrugsDialogBaseModule } from './components/user-board/dialogs/multiple-drugs-dialog-base/multiple-drugs-dialog-base.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MultiselectDropdownModule } from '../shared/components/multiselect-dropdown/multiselect-dropdown.module';
import { SchedulesFilterModule } from '../shared/components/schedules-filter/schedules-filter.module';
import { BulkVerifyModule } from './components/bulk-verify/bulk-verify.module';
import { BulkVerifyComponent } from './components/bulk-verify/bulk-verify.component';
import { BulkVerifyHubService } from '../shared/services/bulk-verify-hub.service';
import { BulkVerifyPillLoaderComponent } from './components/bulk-verify/bulk-verify-pill-loader/bulk-verify-pill-loader.component';
import { ClickAndHoldDirective } from '../shared/directives/click-n-hold/click-n-hold.directive';
import { ClickAndHoldModule } from '../shared/directives/click-n-hold/click-n-hold.module';
import { DupTransactionsService } from '../shared/services/dup-transactions.service';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { MoveInventoryDialogModule } from './components/user-board/dialogs/move-inventory-dialog/move-inventory-dialog.module';
import { TransactionBadgeModule } from '../shared/pipes/transaction-badge/transaction-badge.module';
import { InventoryLocationsFilterModule } from '../shared/components/inventory-locations-filter/inventory-locations-filter.module';
import { OrdersService } from '../inventory/components/receive-edi/orders.service';
import { SideWidgetService } from '../shared/services/side-widget.service';
import { AuditOrderRedirectLinkClassModule } from '../shared/directives/audit-order-redirect-link/audit-order-redirect-link.module';

const routes = [
  {
    // TODO: redirect to Setup if user didn't finish sign-up flow
    path: '', component: DashboardComponent,
  },
  {
    // TODO: redirect to dashboard if user already filled all options
    path: 'set-up',
    component: SetUpComponent,
  },
  {
    path: 'bulk-verify',
    component: BulkVerifyComponent,
    module: BulkVerifyModule,
  },
];

@NgModule({
  declarations: [
    SetPinDialogComponent,
    TransactionsTableComponent,
    UserBoardComponent,
    DashboardComponent,
    SetUpComponent,
    PendingTransactionsCarouselComponent,
    BulkVerifyPillLoaderComponent
  ],
    exports: [
        SetPinDialogComponent
    ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    DialogProgressModule,
    InputModule,
    ReactiveFormsModule,
    DropdownModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    PinInputModule,
    SearchInputModule,
    MenuModule,
    BadgeModule,
    DialogModule,
    InputSearchScannerModule,
    PharmacyDetailsModule,
    AmendDialogModule,
    ButtonModule,
    EnterPinDialogModule,
    AlertModule,
    ResetPinDialogModule,
    FormattedDateModule,
    SearchEmptySplashModule,
    LoaderModule,
    DispenseDialogModule,
    ReceiveDialogModule,
    SellToPharmacyDialogModule,
    RecordLostStolenDialogModule,
    RecordDamagedExpiredDialogModule,
    PendingTransactionCardsModule,
    PendingTransactionDialogModule,
    MultipleDrugsDialogBaseModule,
    InfiniteScrollModule,
    SchedulesFilterModule,
    BulkVerifyModule,
    ClickAndHoldModule,
    MoveInventoryDialogModule,
    TransactionBadgeModule,
    InventoryLocationsFilterModule,
    AuditOrderRedirectLinkClassModule
  ],
  providers: [
    FormattedDatePipe, ClickAndHoldDirective, DupTransactionsService, OrdersService, SideWidgetService
  ],
})
export class DashboardModule {
}
